import { render, staticRenderFns } from "./remove-voucher-popup.vue?vue&type=template&id=4475733e&"
import script from "./remove-voucher-popup.vue?vue&type=script&lang=ts&"
export * from "./remove-voucher-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports